module.exports = __webpack_public_path__ + "media/images/page/scene07-ecd0294a1d1ab50ae9b0db64eec666a3.jpg";